module.exports = __webpack_public_path__ + "img/Question.0a35d794.svg";